// extracted by mini-css-extract-plugin
export default {"sidebarContainer":"theme_sidebarContainer__0c5zD"};